module.exports = __webpack_public_path__ + "assets/img/9.bf514260.png";